import * as Yup from "yup";

// Helpers simples para validar tamanhos reais (sem máscara)
const cleanNumber = (value?: string) => value?.replace(/\D/g, "") ?? "";

export const fireQuoteSchema = Yup.object().shape({
    // ============================
    // CLIENTE / SEGURADORA
    // ============================
    insurance_companiesId: Yup.string()
        .required("Seguradora é obrigatória"),

    propertyType: Yup.string()
        .required("Tipo de imóvel é obrigatório"),

    occupationId: Yup.string()
        .required("Ocupação é obrigatória"),

    assistanceId: Yup.string()
        .required("Assistência é obrigatória"),

    rent_value: Yup.string()
        .required("Valor do aluguel é obrigatório")
        .test("rent-min", "Valor do aluguel deve ser maior que zero", (value) => {
            const num = Number(cleanNumber(value));
            return num > 0;
        }),

    installment_number: Yup.number()
        .required("Número de parcelas é obrigatório")
        .min(1, "Mínimo 1 parcela")
        .max(12, "Máximo de 12 parcelas"),

    // ============================
    // ENDEREÇO
    // ============================
    address_zipcode: Yup.string()
        .required("CEP é obrigatório")
        .test("cep-length", "CEP deve ter 8 dígitos", (value) => cleanNumber(value).length === 8),

    address_street: Yup.string()
        .required("Endereço é obrigatório"),

    address_number: Yup.string()
        .required("Número é obrigatório"),

    address_district: Yup.string()
        .required("Bairro é obrigatório"),

    address_city: Yup.string()
        .required("Cidade é obrigatória"),

    address_state: Yup.string()
        .required("Estado é obrigatório")
        .length(2, "UF deve ter 2 caracteres"),

    // ============================
    // INQUILINO
    // ============================
    tenantName: Yup.string()
        .required("Nome do inquilino é obrigatório")
        .min(3, "Nome do inquilino muito curto"),

    tenantDocument: Yup.string()
        .required("Documento do inquilino é obrigatório")
        .test("cpf-length", "CPF deve ter 11 dígitos", (value) => cleanNumber(value).length === 11),

    tenantEmail: Yup.string()
        .email("E-mail inválido")
        .required("E-mail é obrigatório"),

    tenantMobilePhone: Yup.string()
        .required("Telefone obrigatório")
        .test("phone-min", "Telefone deve ter ao menos 10 dígitos", (value) => cleanNumber(value).length >= 10),

    // ============================
    // PROPRIETÁRIO
    // ============================
    lessorName: Yup.string()
        .required("Nome do proprietário é obrigatório")
        .min(3, "Nome do proprietário muito curto"),

    lessorDocument: Yup.string()
        .required("Documento do proprietário é obrigatório")
        .test("cpf-length", "CPF deve ter 11 dígitos", (value) => cleanNumber(value).length === 11),

    lessorEmail: Yup.string()
        .email("E-mail inválido")
        .required("E-mail é obrigatório"),
});
